<template>
    <div>
		<div class="header" v-bind:class="{ 'header-dimenu': isDimenu }">
			<div class="block" style="height: 50px">
				<div style="display: flex">
					<!-- <div v-if="logo_lang == 'es'">
						<router-link :to="{ name: 'Home' }">
							<img class="logo" alt="Dimenu" src="@/assets/logo_es.png" v-if="isDimenu == false" />
							<img class="logo" alt="Dimenu" src="@/assets/logo_black_es.png" v-else />
						</router-link>
					</div> -->
					<div >
						<router-link :to="{ name: 'Home' }">
							<img class="logo logo_en" alt="Dimenu" src="@/assets/logo_en.png"
								v-if="isDimenu == false" />
							<img class="logo logo_en" alt="Dimenu" src="@/assets/logo_black_en.png" v-else />
						</router-link>
					</div>
					<dropdown-menu v-if="appsorg.length > 0" v-model="show4" :right="right" :hover="hover"
						class="dropAppsArea">
						<button class="btnDrop">
							<span class="Apps-icon-Left"><i class="fas fa-chevron-down"></i></span>
						</button>
						<div slot="dropdown" class="appslist">
							<div class="AreaDropItems">
								<div class="title_app_header">
									{{ $t("lang.label_my_apps") }}
								</div>
								<a class="dropdown-item iconapps" @click="linkApps(i.id, index)"
									v-for="(i, index) in appsorg" :key="i.id">
									<span>
										<img alt="billing" v-if="i.id == 1" src="@/assets/icon_billing.svg"
											style="height: 50px" />
										<img alt="Website" v-else-if="i.id == 2" src="@/assets/icon_dimenu_white.svg"
											style="height: 50px" />
										<img alt="otro" v-else src="@/assets/icon_auxiliar.svg" style="height: 50px" />
									</span>
									{{ i.name }}
								</a>
							</div>
						</div>
					</dropdown-menu>

					<ul class="menuTop menuApps">
						<li v-for="(i, index) in appsorg" :key="i.id" class="dropdown-item noMovil"
							v-bind:class="{ active: activeIndex === index }">
							<a class="iconapps" @click="linkApps(i.id, index)">
								<span>
									<img alt="billing" v-if="i.id == 1 && isDimenu == true"
										src="@/assets/icon_billing_black.svg" style="height: 30px" />
									<img alt="billing" v-else-if="i.id == 1 && isDimenu == false"
										src="@/assets/icon_billing_white.svg" style="height: 30px" />
									<img alt="website" v-else-if="i.id == 2" src="@/assets/icon_dimenu_white.svg"
										style="height: 30px" />
									<img alt="otro" v-else src="@/assets/icon_auxiliar_white.svg"
										style="height: 30px" />
								</span>
								{{ i.name }}
							</a>
						</li>
					</ul>
				</div>
			</div>
			<div class="block">
				<ul class="menuTop">
					<li v-if="organizationslist.length > 0">
						<dropdown-menu v-model="show2" :right="right" :hover="hover">
							<button class="btnDrop">
								<span class="nomOrgSelected">{{ orgSelect }} </span>
								<i class="fas fa-briefcase iconMaletin"></i>
								<i class="fas fa-chevron-down" style="font-size: 12px; margin-left: 5px"></i>
							</button>
							<div slot="dropdown" v-if="orgdata">
								<div class="dropdown-item" v-for="i in organizationslist" :key="i.id"
									@click="ChangeOrg(i.id)" style="width: 250px">
									<a class="text-left active" v-if="orgIDSelect == i.id">
										{{ i.bill_company_name }}
										<b class="badge badge-success" v-if="i.principal == 1" style="
												margin: 5px;
												font-size: 9px;
												float: right;
											">{{ $t("lang.label_primary") }}</b>
									</a>
									<a class="text-left noactive" v-else>
										{{ i.bill_company_name }}
										<b class="badge badge-success" v-if="i.principal == 1" style="
												margin: 5px;
												font-size: 9px;
												float: right;
											">{{ $t("lang.label_primary") }}</b>
									</a>
								</div>
							</div>
						</dropdown-menu>
					</li>
					<li v-if="
							urlWebDimenu != '' &&
							urlWebDimenu != 'null' &&
							urlWebDimenu != null
						">
						<a :href="urlWebDimenu" target="_black" class="link-webiste-dimenu">
							<i class="fas fa-external-link-alt fa-sm"></i>
						</a>
					</li>
					<li>
						<button class="btn-refresh" @click="refreshApp">
							<i class="fas fa-sync-alt" v-bind:class="{ 'icons': !isDimenu }"></i>
							<span class="tooltip">Actualizar</span>
						</button>
					</li>
					<li v-if="lang > 0 && showLang == 'On'">
						<dropdown-menu v-model="show3" :right="right" :hover="hover">
							<button class="btnDrop">
								<span class="nomOrgSelected">
									<img alt="usa" src="@/assets/flag-usa.png" v-if="lang == 1" style="height: 30px" />
									<img alt="spain" src="@/assets/flag-spain.png" v-if="lang == 2"
										style="height: 30px" />
								</span>
							</button>
							<div slot="dropdown" v-if="orgdata">
								<div class="dropdown-item" @click="ChangeLang(2)">
									<a class="text-left noactive">
										<img alt="spain" src="@/assets/flag-spain.png" style="height: 20px" />
										{{ $t("lang.label_spain") }}
										<b class="badge badge-success" v-if="lang == 2" style="
												margin: 5px;
												font-size: 9px;
												float: right;
											">{{ $t("lang.msj_active") }}</b>
									</a>
								</div>
								<div class="dropdown-item" @click="ChangeLang(1)">
									<a class="text-left active">
										<img alt="usa" src="@/assets/flag-usa.png" style="height: 20px" />
										{{ $t("lang.label_english") }}
										<b class="badge badge-success" v-if="lang == 1" style="
												margin: 5px;
												font-size: 9px;
												float: right;
											">{{ $t("lang.msj_active") }}</b>
									</a>
								</div>
							</div>
						</dropdown-menu>
					</li>
					<li>
						<dropdown-menu v-model="show" :right="right" :hover="hover">
							<button class="btnDrop">
								<i class="fas fa-user-circle iusericon"></i>
							</button>
							<div slot="dropdown" class="menu-account">
								<li class="dropdown-item accactive" v-if="orgdata && user_type == 0"
									style="width: 250px; padding: 0.25rem 1.5rem">
									{{ orgdata.com_company_name }}
									<router-link :to="{ name: 'Organizations' }" class="subMenuOrg">{{ $t("lang.label_my_orgs") }}
									</router-link>
									<router-link :to="{ name: 'AddOrganization' }" class="subMenuOrg">{{ $t("lang.label_add_new") }}
									</router-link>
								</li>
								<li class="dropdown-item" style="width: 250px" v-if="user_type == 0">
									<router-link :to="{ name: 'Profile' }">{{
													$t("lang.label_my_acct")
												}}</router-link>
								</li>
								<li class="dropdown-item" style="width: 250px" v-if="user_type == 0">
									<router-link :to="{ name: 'Users' }">{{
													$t("lang.label_users")
												}}</router-link>
								</li>
								<li class="dropdown-item" style="width: 250px" v-if="user_type == 0">
									<router-link :to="{ name: 'Security' }">{{
													$t("lang.label_security")
												}}</router-link>
								</li>
								<li class="dropdown-item" style="
													width: 250px;
													cursor: pointer;
													padding-top: 8px;
													margin-top: 11px;
													border-top: 1px solid #ececec;
												">
									<a @click="logout"><span class="logout">{{
														$t("lang.label_sign_out")
													}}</span></a>
								</li>
							</div>
						</dropdown-menu>
					</li>
				</ul>
			</div>
		</div>
        <!-- <div id="loading" v-if="isLoading"><div class="op-loading"></div></div> -->
    </div>
</template>
<script>
import DropdownMenu from "@innologica/vue-dropdown-menu";
import { mapGetters } from "vuex";
import axios from "axios";
export default {
    name: "Header",
    components: {
        DropdownMenu,
    },
    data () {
        return {
            isLoading: false,
            show4: false,
            show3: false,
            show2: false,
            show: false,
            transition: "",
            right: true,
            hover: false,
            organizationslist: [],
            org_id: 0,
            org_id_old: 0,
            orgSelect: "My Organization",
            orgIDSelect: 0,
            app: "Home",
            emailVerify: window.emailVerify,
            // app: null,
            activeIndex: null,
            user_type: window.user_type,
            isDimenu: false,
            lang: 0,
            logo_lang: window.langLocal,
            showLang: window.showLang,
        }
    },
    created () {
        this.lang = window.langLocal == "en" ? 1 : 2;
        this.activeIndex = Number(localStorage.getItem("menu_top_active"));
        if (
            this.$router.currentRoute.name === "Home" ||
            this.$router.currentRoute.name === "Profile" ||
            this.$router.currentRoute.name === "Organizations" ||
            this.$router.currentRoute.name === "Security" ||
            this.$router.currentRoute.name === "Users" ||
            this.$router.currentRoute.name === "Privilegies" ||
            this.$router.currentRoute.name === "PrivilegiesList" ||
            this.$router.currentRoute.name === "AddOrganization"
        ) {
            this.app = "Home";
            this.activeIndex = null;
        } else {
            this.app = null;
        }
        if (localStorage.getItem("appIDactual") == 2) {
            this.isDimenu = true;
        }
        // console.log('$router= ', this.$router.currentRoute.name)
        this.isLoading = true;
        //this.$store.dispatch('Only_exit_Apps');
        this.$store.dispatch("validToken").then((response) => {
            // console.log('validando token master desde header ', response.data);
            if (response.data.tokenValid) {
                if (!this.$store.getters.loggedIn) {
                    //console.log('enviando a login para iniciar sesion de dash');
                    this.$router.push({ name: "Logout" });
                } else {
                    this.$store.dispatch("privilegies_session").then((response) => {
                        this.$store
                            .dispatch(
                                "ActiveOrgdataByUser",
                                localStorage.getItem("mark_client_data")
                            )
                            .then((response) => {
                                if (window.user_type == 0) {
                                    this.$store.dispatch(
                                        "ListAppsbyOrg",
                                        localStorage.getItem("mark_client_data")
                                    );
                                } else {
                                    this.$store.dispatch(
                                        "ListAppsForOrgOfSecondary",
                                        localStorage.getItem("mark_client_data")
                                    );
                                }
                                this.getOrganizations();
                                this.getRInfo();
                            });
                    });
                }
            } else {
                console.log("sesion caducada saliendo del sistema");
                this.$router.push({ name: "Logout" });
            }
        });
    },
    methods: {
        refreshApp() {
            let d = new Date();
            let t = d.getTime();
            console.log(t);
            window.location = window.location.href + "?cache=false&" + t;
        },
        getRInfo() {
            let t = this;
            window.master
                .get(
                    "menu/information/" + window.master_client + "/" + window.localorgdata
                )
                .then((response) => {
                    if (response.data.status == true) {
                        let url = "";
                        if (
                            response.data.result.website_menu_link &&
                            response.data.result.website_menu_link!=null &&
                            response.data.result.website_menu_link!='null' &&
                            response.data.result.website_menu_link!='undefined' &&
                            response.data.result.website_menu_link.length > 0
                        ) {
                            url = response.data.result.website_menu_link;
                        } else {
                            url = window.urlweb + response.data.result.url;
                        }
                        t.$store.commit("set_urlWebDimenu", url);
                    }
                })
                .catch((error) => {});
        },
        ChangeLang(i) {
            if (this.lang != i) {
                let lang = i == 1 ? "en" : "es";
                window.langLocal = lang;
                localStorage.setItem("langLocal", window.langLocal);
                window.location.reload(true);
            }
        },
        homeAccount() {
            console.log("volver a dash");
            this.$router.push({ name: "Home" });
        },
        OrgPages() {
            this.$router.push({ name: "Organizations" });
        },
        linkApps(app_id, index) {
            let a = localStorage.getItem("access_token_m");
            let o = localStorage.getItem("oauth_m");
            let u = localStorage.getItem("mark_client_data_m");
            let org = localStorage.getItem("mark_client_data");
            window.master
                .get("getappid/" + org + "/" + app_id)
                .then((response) => {
                    let r = response.data.r;
                    let nomApp = r.name;
                    localStorage.setItem("menu_top_active", index);
                    localStorage.setItem("applive", app_id);
                    // console.log('app= '+nomApp, 'iD= '+app_id);
                    this.$store.dispatch("apps_modulos", app_id).then((response) => {
                        this.$store.dispatch("SET_APP_ID", app_id);
                        if (app_id == 2) {
                            this.$router.push({ name: "Menu" });
                        } else {
                            this.$router.push({ name: nomApp });
                        }
                    });
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        ChangeOrg(id) {
            var continuarInApp = false;
            this.isLoading = true;
            this.org_id = id;
            let e = this.organizationslist;
            for (let i in e) {
                if (e[i].id == id) {
                    this.orgSelect = e[i].bill_company_name;
                    this.orgIDSelect = id;
                }
            }
            let userfolder = window.localAccountID + "/" + this.org_id;
            localStorage.setItem("mark_client_data", this.org_id);
            localStorage.setItem("folder_user", userfolder);
            localStorage.setItem("nomCompany", this.orgSelect);
            //console.log('cambiado org '+ this.org_id_old+ ' por '+this.org_id);
            //console.log('obteniendo nueva valiable org_id= '+localStorage.getItem('mark_client_data'));
            window.localuserdata = localStorage.getItem("mark_client_data");
            window.localorgdata = localStorage.getItem("mark_client_data");
            //console.log('lista de apps de org antes del cambio ', this.$store.getters.applistorgs);
            this.$store.dispatch("ActiveOrgdataByUser", this.org_id).then((response) => {
                if (
                    this.$router.currentRoute.name === "Home" ||
                    this.$router.currentRoute.name === "Profile" ||
                    this.$router.currentRoute.name === "Organizations" ||
                    this.$router.currentRoute.name === "Security" ||
                    this.$router.currentRoute.name === "Users" ||
                    this.$router.currentRoute.name === "Privilegies" ||
                    this.$router.currentRoute.name === "PrivilegiesList" ||
                    this.$router.currentRoute.name === "AddOrganization"
                ) {
                    continuarInApp = true;
                    this.redireccionChange(continuarInApp);
                } else if (window.user_type == 0) {
                    this.$store.dispatch("ListAppsbyOrg", id).then((response) => {
                        let apps = response;
                        console.log("apps de org ", response);
                        for (let i in apps) {
                            if (apps[i].id == localStorage.getItem("applive")) {
                                continuarInApp = true;
                            }
                        }
                        this.redireccionChange(continuarInApp);
                    });
                } else {
                    this.$store
                        .dispatch("ListAppsForOrgOfSecondary", id)
                        .then((response) => {
                            let apps = response;
                            console.log("userSecundary apps de org ", response);
                            for (let i in apps) {
                                if (apps[i].id == localStorage.getItem("applive")) {
                                    continuarInApp = true;
                                }
                            }
                            this.redireccionChange(continuarInApp);
                        });
                }
            });
        },
        redireccionChange(continuarInApp) {
            if (continuarInApp) {
                window.location.reload(true);
            } else {
                //this.$store.dispatch('exit_Apps');
                this.$swal.fire({
                    type: "error",
                    title: window.lang2.msj_slted_org_not_app,
                    showConfirmButton: false,
                    timer: 4000,
                });
                this.$router.push({ name: "Home" });
            }
        },
        getOrganizations() {
            this.isLoading = true;
            this.$store.dispatch("OrgAccountAll").then((response) => {
                //console.log('aquiiii', this.$store.getters.getListOrgs);
                this.organizationslist = response.data.result;
                this.org_id = localStorage.getItem("mark_client_data");
                this.org_id_old = localStorage.getItem("mark_client_data");
                this.orgSelect = localStorage.getItem("nomCompany");
                this.orgIDSelect = localStorage.getItem("mark_client_data");
                this.isLoading = false;
                this.$store.dispatch("IngresoAccount", true);
            });
        },
        logout() {
            this.$router.push({ name: "Logout" });
        },
    },
    computed: {
        ...mapGetters({
            orgdata: "orginf",
            appsorg: "applistorgs",
            urlWebDimenu: "get_urlWebDimenu",
        }),
    },
};
</script>
<style lang="scss">
.tooltip {
    background-color: #333;
    font-size: 12px;
    padding: 5px 10px;
    color: #fff;
    position: absolute;
    left: 50%;
    top: 100%;
    margin-top: 5px;
    transform: translateX(-50%);
    width: auto;
    z-index: 15;
    border-radius: 2px;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease-in-out;
    &:before {
        content: "";
        display: block;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 0 7.5px 6px 7.5px;
        border-color: transparent transparent #333 transparent;
        position: absolute;
        left: 50%;
        margin-left: -7.5px;
        top: -6px;
    }
}
.btn-refresh {
    border: 0;
    background-color: transparent;
    cursor: pointer;
    height: 50px;
    width: 42px;
    background-color: #ffffff29;
    position: relative;
}
.btn-refresh {
    &:hover {
        background-color: #ffffff42;
        .tooltip {
            opacity: 1;
            visibility: visible;
        }
    }
}
.btn-refresh i {
    color: black;
}

.iusericon {
    font-size: 24px;
    width: 37px;
}
.Apps-icon-Left img {
    width: 25px;
    fill: #fff;
    font-size: 23px;
}
.AreaDropItems {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}

.dropAppsArea {
    position: initial !important;
}
.dropAppsArea span {
    display: block;
    text-align: center;
}
.dropAppsArea span ion-icon {
    font-size: 20px;
}
.dropAppsArea .dropdown-item {
    color: #000;
    border-radius: 3px;
    padding: 0.25rem 0.5rem;
    font-size: 14px;
    text-align: center;
}
.dropAppsArea .dropdown-item:hover {
    background-color: #f7f7f7;
}

.dropAppsArea .dropdown-menu-right {
    left: 0 !important;
}
.dropAppsArea .dropdown-menu.show {
    background: #fff !important;
    top: 97%;
    width: max-content;
    padding-left: 7px;
    padding-right: 7px;
    box-shadow: 1px 1px 5px #272727;
    width: 400px;
}
.AreaDropItems .iconapps {
    display: flex;
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
}

.icon-help {
    color: #000;
    font-size: 11px;
    top: -2px;
    position: relative;
}
.icon-profile {
    font-size: 26px;
    margin-top: 6px;
}
.header {
    position: fixed;
    background: #0a0a0a;
    height: 50px;
    width: 100%;
    display: flex;
    align-items: center;
    z-index: 9999;
    top: 0;
}
.helpicon {
    position: relative;
    width: 20px;
    height: 20px;
    background-color: #b7b5b5;
    display: block;
    border-radius: 50%;
}
.helpicon i {
    font-size: 10px;
    color: #000;
    top: -3px;
    position: relative;
}
.block {
    display: inline-block;
    width: 50%;
}
.logo {
    text-align: left;
    display: block;
    padding: 5px;
    padding-left: 15px;
    padding-right: 0;
    max-width: 130px;
    margin-top: 0px;
}
.menuTop {
    position: relative;
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: flex-end;
    list-style-type: none;
}
.menuTop li {
    position: relative;
}
.menuTop li a {
    font-size: 10px;
    color: #757474;
    text-transform: uppercase;
}
.logout {
    background-color: #e85454 !important;
    color: #fff;
    padding: 4px;
    border-radius: 4px;
}
.dropdown {
    position: relative;
    display: inline-block;
}
.btnDrop {
    border: 0;
    background-color: transparent;
    color: #fff;
    height: 50px;
    cursor: pointer;
    margin-left: 10px;
}
.btnDrop:hover {
    background-color: #5a5856;
}
.dropdown-menu.show {
    display: block;
}
.dropdown-menu {
    position: absolute;
    overflow: hidden;
    top: 100%;
    left: 5px;
    z-index: 999999;
    display: none;
    float: left;
    min-width: 10rem;
    padding: 0.5rem 0;
    margin: 0.125rem 0 0;
    font-size: 1rem;
    color: #212529;
    text-align: left;
    list-style: none;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 0.25rem;
}
.dropdown-item {
    display: block;
    width: 100%;
    padding: 0.25rem 1.5rem;
    clear: both;
    font-weight: 400;
    color: #212529;
    text-align: inherit;
    white-space: nowrap;
    background-color: transparent;
    border: 0;
    text-decoration: none;
    padding: 7px 10px;
}
.dropdown-item:hover {
    background-color: #f3f3f3;
    cursor: pointer;
}
.accactive {
    position: relative;
    max-width: 250px;
    border-bottom: 1px solid #eae8e8;
    line-height: 17px;
    padding-bottom: 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.accactive .iedit {
    position: absolute;
    right: 6px;
    top: 0px;
    font-size: 14px;
    width: 40px;
    height: 100%;
    cursor: pointer;
    border-radius: 50%;
    padding: 12px 5px;
    text-align: center;
    border: 1px solid #ccc;
}
.accactive .iedit:hover {
    background-color: #f1eded;
}
.iedit ion-icon {
    color: #73716f;
    font-size: 19px;
}
ul.menuTop.menuApps li.dropdown-item.active {
    background-color: #585858 !important;
}
.menuApps .dropdown-item:focus,
.menuApps .dropdown-item:hover {
    background-color: #585858;
    cursor: pointer;
}
.menuApps .dropdown-item:active {
    background-color: #585858;
}
.menuApps .dropdown-item {
    padding: 0.25rem 0px 0px 0px;
}
a.iconapps {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 0rem 1rem;
}
ul.menuTop.menuApps {
    margin-left: 20px;
    height: 50px;
}
.menu-account .dropdown-item {
    padding: 0px;
}

.menu-account .dropdown-item a {
    padding: 0.25rem 1.5rem;
    display: block;
}
#loading {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.9);
    z-index: 999999;
    border-radius: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.dropdown-menu-right {
    right: 0;
    left: auto;
}

.title_app_header {
    position: relative;
    display: block;
    margin-top: 0px !important;
    font-size: 23px;
    font-weight: normal;
    color: #6f6f6f;
    text-align: center;
    font-weight: bold;
    width: 100%;
    height: 50px;
}
.title_app_header:after {
    content: "";
    width: 40px;
    height: 3px;
    background-color: #019720;
    margin: 0 auto;
    display: block;
    margin-top: 5px;
}
a.text-left.active {
    font-weight: 900;
}
.iconMaletin {
    display: none;
}
span.nomOrgSelected {        
    font-size: x-large;
}
@media (max-width: 767px) {
    .dropAppsArea .dropdown-menu.show {
        width: 100%;
    }
    .noMovil {
        display: none;
    }
    .btnDrop {
        margin-left: 0px;
    }
    span.nomOrgSelected {        
        font-size: x-large;
        display: none;
    }
    .iconMaletin {
        display: inline-block;
        font-size: 24px;
        margin-right: 5px;
    }
}
.menuTop li a.subMenuOrg {
    font-size: 11px;
    display: block;
    color: #757474;
    line-height: 0.9em;
}
.menuTop li a.subMenuOrg:hover {
    color: #000 !important;
}
.menuTop li a {
    color: #fff !important;
}
.icons{
    color: #eee !important;
}
.header.header-dimenu {
    background: #ffffff;
}
.header.header-dimenu .menuTop li a {
    color: #000 !important;
}
.header .menuTop li .dropdown-item a {
    color: #000 !important;
}
.header.header-dimenu ul.menuTop.menuApps li.dropdown-item.active {
    background-color: #eeeeee !important;
}
.header.header-dimenu > .block > ul.menuTop > li .dropdown > .btnDrop {
    color: #222223 !important;
}
.header.header-dimenu > .block > ul.menuTop > li .dropdown > .btnDrop.btnDrop:hover {
    background-color: #eeeeee;
}
.logo_en {
    padding-top: 10px;
}
.dropdown.dropAppsArea .btnDrop {
    margin-left: 0px;
}
.header.header-dimenu .dropdown.dropAppsArea .btnDrop {
    color: #000;
}
.link-webiste-dimenu {
    padding: 15px 0px 0px 15px;
    display: block;
    font-size: 15px !important;
}
</style>
